import Cookies from 'js-cookie'
import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'

const TOKEN_KEY = 'erkeAiStoreToken'
// cookie 有效期 3 天
const TOKEN_EXPIRES = 3

export function getToken() {
  return Cookies.get(TOKEN_KEY) || ''
}

export function setToken(token) {
  if (!token) return
  Cookies.set(TOKEN_KEY, token, { expires: TOKEN_EXPIRES })
}

export function removeToken() {
  Cookies.remove(TOKEN_KEY)
}

/**
 * 获取验证码
 */
export function getCaptcha(data) {
  return request({
    url: `${apiConfig.ZY}/rightActivityH5/sendCaptcha`,
    method: 'post',
    // 2403 由页面自定义弹框，关闭拦截器默认 toast
    isShowErrorMessage: true,
    data: {
      phone: data.phone,
      bizType: data.bizType
    }
  })
}

/**
 * 登录（手机号 + 验证码），data 为 token 字符串
 */
export function login(data) {
  return request({
    url: `${apiConfig.ZY}/rightActivityH5/login`,
    method: 'post',
    data: {
      phone: data.phone,
      captchaCode: data.captchaCode,
      bizType: data.bizType
    }
  })
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
  return request({
    url: `${apiConfig.ZY}/rightActivityH5/order/getUserInfo`,
    method: 'post',
    token: getToken()
  })
}

/**
 * 获取活动领取信息（奖项列表）
 */
export function getActivityPrizeInfo() {
  return request({
    url: `${apiConfig.ZY}/rightActivityH5/order/getActivityPrizeInfo`,
    method: 'post',
    token: getToken()
  })
}

/**
 * 领取奖品
 */
export function receivePrize(data) {
  return request({
    url: `${apiConfig.ZY}/rightActivityH5/order/receive`,
    method: 'post',
    token: getToken(),
    data: {
      id: data.id,
      goodId: data.goodId
    }
  })
}

/**
 * 我的奖品分页
 */
export function getOrderPages(data = {}) {
  return request({
    url: `${apiConfig.ZY}/rightActivityH5/order/pages`,
    method: 'post',
    token: getToken(),
    data: data
  })
}
